import { render, staticRenderFns } from "./roleAndPermissions.vue?vue&type=template&id=bdb21fcc&scoped=true"
import script from "./roleAndPermissions.vue?vue&type=script&lang=js"
export * from "./roleAndPermissions.vue?vue&type=script&lang=js"
import style0 from "./roleAndPermissions.vue?vue&type=style&index=0&id=bdb21fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb21fcc",
  null
  
)

export default component.exports